import React from "react";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { GenericListProps } from "../../types/GenericListType";
import { Image, ImageProps } from "../../components/Image/Image";
import { List } from "../../components/List";
import { GreyCard, GreyCardProps } from "../../components/GreyCard";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { GroupedComponents } from "../../components/GroupedComponents";

export interface HotWaterOutagesPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  lists?: GenericListProps[];
  images?: ImageProps[];
  wantToReport?: GreyCardProps;
  faqs?: FaqAccordionGroupProps;
}

export const HotWaterOutagesPage: React.FC<HotWaterOutagesPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  lists,
  images,
  wantToReport,
  faqs,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      <GroupedComponents>
        {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
        {lists && lists[0] && <List {...lists[0]} />}
        {paragraphs && paragraphs[1] && <Paragraph {...paragraphs[1]} />}
        {lists && lists[1] && <List {...lists[1]} />}
        {paragraphs && paragraphs[2] && <Paragraph {...paragraphs[2]} />}
      </GroupedComponents>
      {images && images[0] && <Image {...images[0]} />}
      {paragraphs && paragraphs[3] && <Paragraph {...paragraphs[3]} />}
      {wantToReport && <GreyCard {...wantToReport} />}
    </ServiceCataloguePageWrapper>
  );
};
